module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/tactical-training-elite.29386146.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/tactical-training-elite.png
// module id = 3808
// module chunks = 11